<template>
    <vx-card class="list-view-item mb-base overflow-hidden">

        <template slot="no-body">
            <div class="vx-row item-details no-gutter">

                <!-- IMG COL -->
                <template v-if="item.imageUrl == ''">
                <div class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center">
                    <img  v-bind:src="require('@/assets/images/no-imagen.jpg')" alt="img-placeholder" class="grid-view-img p-4">
                </div>
                </template>
                <template v-else>
                <div class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center">
                    <img :src="$store.state.domain+'mapgrafi/ecommerce/searchFile/'+item.imageUrl" :alt="item.name" class="grid-view-img p-4">
                </div>
                </template>

                <!-- ITEM NAME & DESC COL -->
                <div class="vx-col sm:w-1/2">
                    <div class="p-4 pt-6">
                        <slot name="item-meta">
                            <h6 class="item-name font-semibold mb-1">{{ item.name }}</h6>
                            <p class="text-sm mb-4 cursor-pointer">By <span class="text-primary font-semibold">{{ item.brand }}</span></p>
                            <p class="item-description text-sm">{{ item.description }}</p>
                        </slot>
                    </div>
                </div>

                <!-- PURCHASE COL -->
                <div class="vx-col sm:w-1/4 w-full flex items-center border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

                    <div class=" flex flex-col w-full">
                        <div class="my-6">
                            <h5 class="font-bold text-center">Precio Uni.<br>${{ _.round(item.price,2).toFixed(2) }}</h5>
                            <h5 class="font-bold text-center">Total <br>${{ _.round(item.subtotal,2).toFixed(2)}}</h5> <!-- SIN IVA-->
                            <h5 class="font-bold text-center" v-if="statusPreventa">Con descuento <br>${{ _.round(item.total *100,2).toFixed(2) }}</h5>
                        
                            <!-- <h5 class="font-bold text-center">Precio Uni.<br>${{ parseFloat(item.price).toFixed(2) }}</h5>
                            <h5 class="font-bold text-center">Total <br>${{ parseFloat(item.subtotal).toFixed(2) }}</h5>
                            <h5 class="font-bold text-center" v-if="statusPreventa">Con descuento <br>${{ parseFloat(item.total) }}</h5>
                             -->
                        </div>

                        <!-- SLOT: ACTION BUTTONS -->
                        <slot name="action-buttons" />
                    </div>
                </div>
            </div>
        </template>

    </vx-card>
</template>

<script>
export default{
    props: {
        item: {
            type: Object,
            required: true
        },
        statusPreventa: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        isInCart() {
            return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
        },
        isInWishList() {
            return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
        },
    },
    methods: {
        toggleItemInWishList(item) {
            this.$store.dispatch('eCommerce/toggleItemInWishList', item)
        },
        additemInCart(item) {
            this.$store.dispatch('eCommerce/additemInCart', item)
        },
        cartButtonClicked(item) {
            this.isInCart(item.objectID) ? this.$router.push('/apps/eCommerce/checkout').catch(() => {}) : this.additemInCart(item)
        }
    },
}
</script>

<style lang="scss" scoped>
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
